import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";

@Component({})
export default class SubscriptionsOrderProducts extends Vue {
  
  // getters
  @Getter getCurrentOrder;

  // Mutations
  @Mutation CURRENT_ORDER;

  isLoading = false;
  subscriptionMenus = [];

  mounted() {
    this.subscriptionMenus = this.getCurrentOrder.details_subscription_menus.filter(
      (menu) => menu.day.length
    );
  }

  sortDays(menuOptionDays) {
    const sortFunction = (a, b) => {
      return a.count_id - b.count_id;
    }
    return menuOptionDays.sort(sortFunction);
  }

  _showError(error) {
    let msg = "";
    if(error && error.response && error.response.data && error.response.data.message) {
      msg = error.response.data.message;
    }
    this.$swal({
      title: "Error",
      text: `Error al enviar la solicitud. ${msg}`
    });
  }
}
